import siteConfig from '@/localized/config/site';

export const zendeskID = siteConfig.zendeskID;
